import axios from 'axios'
import store from '../store'
import { notificationActions, accountActions } from '../actions'

const url =
    process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_API_URL
        : process.env.REACT_APP_PROD_API_URL

const backend = axios.create({ baseURL: url })

// Códigos de la API de planillas: 610 tomada por otro usuario, 611 inexistente o reemplazado, 612 vencido
const lockErrors = [610, 611, 612]

backend.interceptors.request.use(config => {
    const lockId = sessionStorage.getItem("lockId")
    if (lockId) {
        config.headers["X-Lock-Id"] = lockId
    }
    return config
})

backend.interceptors.response.use(
    res => res,
    err => {
        if (!err.response) {
            store.dispatch(notificationActions.showError(
                { message: "Error de conexión al servidor" }))

            return Promise.reject({ ...err, intercepted: true })
        }

        const lockError = err.response.data?.errors?.find(e => lockErrors.includes(e.errorCode))

        if (lockError) {
            sessionStorage.removeItem("lockId")

            window.dispatchEvent(new CustomEvent("lock-lost", { detail: lockError }))

            return Promise.reject({ ...err, intercepted: true })
        }

        switch (err.response.status) {
            case 401:
                store.dispatch(notificationActions.showError(
                    { message: "La sesión actual ya no es válida" }))
                store.dispatch(accountActions.invalidToken())

                return Promise.reject(
                    { ...err, intercepted: true, })
            case 500:
                store.dispatch(notificationActions.showError(
                    { message: "Error interno del servidor" }))

                return Promise.reject(
                    { ...err, intercepted: true })
            default:
                return Promise.reject(err)
        }
    }
)

export default backend
